import { FC } from 'react';
import Radio from 'components/ui/radio';
import { useTranslation } from 'hooks';

interface Props {
  id: string;
  title: string;
  img: string;
  selectedId: string;
  onSelect: (id: string) => void;
}

export const ThemeSwitchCard: FC<Props> = ({
  id,
  title,
  img,
  selectedId,
  onSelect,
}) => {
  const getTranslate = useTranslation();

  return (
    <div className='theme-switcher-card'>
      <div className='theme-switcher-card__img'>
        <img src={img} alt='custom-theme' width={114} height={64} />
      </div>
      <Radio
        id={id}
        text={getTranslate(title)}
        isChecked={id === selectedId}
        onChange={(e) => onSelect(e.target.id)}
      />
    </div>
  );
};
